export default __webpack_public_path__ + "static/media/MobileCardIcon.ad3f7318.svg";